__turbopack_context__.v({
  "brandLockup": "LandingPage-module-scss-module__gMpK2W__brandLockup",
  "brandWordmark": "LandingPage-module-scss-module__gMpK2W__brandWordmark",
  "contactCard": "LandingPage-module-scss-module__gMpK2W__contactCard",
  "contactGrid": "LandingPage-module-scss-module__gMpK2W__contactGrid",
  "contactLabel": "LandingPage-module-scss-module__gMpK2W__contactLabel",
  "contactShortcut": "LandingPage-module-scss-module__gMpK2W__contactShortcut",
  "contactShortcutLink": "LandingPage-module-scss-module__gMpK2W__contactShortcutLink",
  "contactShortcutWithNotice": "LandingPage-module-scss-module__gMpK2W__contactShortcutWithNotice",
  "contactValue": "LandingPage-module-scss-module__gMpK2W__contactValue",
  "downloadNotice": "LandingPage-module-scss-module__gMpK2W__downloadNotice",
  "downloadNoticeCopy": "LandingPage-module-scss-module__gMpK2W__downloadNoticeCopy",
  "downloadNoticeTitle": "LandingPage-module-scss-module__gMpK2W__downloadNoticeTitle",
  "hero": "LandingPage-module-scss-module__gMpK2W__hero",
  "heroAccentGlow": "LandingPage-module-scss-module__gMpK2W__heroAccentGlow",
  "heroActionIcon": "LandingPage-module-scss-module__gMpK2W__heroActionIcon",
  "heroActionPrimary": "LandingPage-module-scss-module__gMpK2W__heroActionPrimary",
  "heroActionSecondary": "LandingPage-module-scss-module__gMpK2W__heroActionSecondary",
  "heroActions": "LandingPage-module-scss-module__gMpK2W__heroActions",
  "heroCopy": "LandingPage-module-scss-module__gMpK2W__heroCopy",
  "heroDescription": "LandingPage-module-scss-module__gMpK2W__heroDescription",
  "heroDescriptionLine": "LandingPage-module-scss-module__gMpK2W__heroDescriptionLine",
  "heroEnter": "LandingPage-module-scss-module__gMpK2W__heroEnter",
  "heroEyebrow": "LandingPage-module-scss-module__gMpK2W__heroEyebrow",
  "heroLogo": "LandingPage-module-scss-module__gMpK2W__heroLogo",
  "heroMaskedText": "LandingPage-module-scss-module__gMpK2W__heroMaskedText",
  "heroPromise": "LandingPage-module-scss-module__gMpK2W__heroPromise",
  "heroRotatingPhrase": "LandingPage-module-scss-module__gMpK2W__heroRotatingPhrase",
  "heroRotatingTerm": "LandingPage-module-scss-module__gMpK2W__heroRotatingTerm",
  "heroRotatingTermAudienceCompact": "LandingPage-module-scss-module__gMpK2W__heroRotatingTermAudienceCompact",
  "heroRotatingTermSubject": "LandingPage-module-scss-module__gMpK2W__heroRotatingTermSubject",
  "heroRotatingTermSubjectCompact": "LandingPage-module-scss-module__gMpK2W__heroRotatingTermSubjectCompact",
  "heroRotator": "LandingPage-module-scss-module__gMpK2W__heroRotator",
  "heroRotatorConnector": "LandingPage-module-scss-module__gMpK2W__heroRotatorConnector",
  "heroRotatorPhraseSlot": "LandingPage-module-scss-module__gMpK2W__heroRotatorPhraseSlot",
  "heroRotatorSlot": "LandingPage-module-scss-module__gMpK2W__heroRotatorSlot",
  "heroRotatorSlotAudience": "LandingPage-module-scss-module__gMpK2W__heroRotatorSlotAudience",
  "heroRotatorSlotSubject": "LandingPage-module-scss-module__gMpK2W__heroRotatorSlotSubject",
  "heroRotatorSplit": "LandingPage-module-scss-module__gMpK2W__heroRotatorSplit",
  "heroSignInPrompt": "LandingPage-module-scss-module__gMpK2W__heroSignInPrompt",
  "heroSignInStack": "LandingPage-module-scss-module__gMpK2W__heroSignInStack",
  "heroTitle": "LandingPage-module-scss-module__gMpK2W__heroTitle",
  "heroTitleAccent": "LandingPage-module-scss-module__gMpK2W__heroTitleAccent",
  "heroTitleLead": "LandingPage-module-scss-module__gMpK2W__heroTitleLead",
  "heroVisual": "LandingPage-module-scss-module__gMpK2W__heroVisual",
  "investorCard": "LandingPage-module-scss-module__gMpK2W__investorCard",
  "investorLead": "LandingPage-module-scss-module__gMpK2W__investorLead",
  "investorList": "LandingPage-module-scss-module__gMpK2W__investorList",
  "investorReveal": "LandingPage-module-scss-module__gMpK2W__investorReveal",
  "investorStack": "LandingPage-module-scss-module__gMpK2W__investorStack",
  "investorWideCard": "LandingPage-module-scss-module__gMpK2W__investorWideCard",
  "investorsRegion": "LandingPage-module-scss-module__gMpK2W__investorsRegion",
  "loginButton": "LandingPage-module-scss-module__gMpK2W__loginButton",
  "overviewGrid": "LandingPage-module-scss-module__gMpK2W__overviewGrid",
  "root": "LandingPage-module-scss-module__gMpK2W__root",
  "rootWithNotice": "LandingPage-module-scss-module__gMpK2W__rootWithNotice",
  "topBar": "LandingPage-module-scss-module__gMpK2W__topBar",
  "topBarActions": "LandingPage-module-scss-module__gMpK2W__topBarActions",
  "topBarFade": "LandingPage-module-scss-module__gMpK2W__topBarFade",
  "topBarInner": "LandingPage-module-scss-module__gMpK2W__topBarInner",
});
